import React from "react";
import { IconBaseProps } from "react-icons";

export const HeadSetSVG: React.FC<IconBaseProps> = ({ fill = "currentColor", size = 26 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill={fill}
    fillRule="evenodd"
    display="block"
  >
    <path d="M13.009 3C7.495 3 3 8.206 3 14.571c0 1.501.246 3.002.737 4.427.58 1.729 2.002 2.964 3.723 3.002.492 0 .896-.437.896-.969v-5.529c0-.532-.404-.969-.896-.969-.895 0-1.756.361-2.406.893-.035-.304-.035-.57-.035-.893 0-5.206 3.6-9.405 8.007-9.405 4.408 0 8.007 4.237 8.007 9.405 0 .304 0 .627-.035.893-.65-.57-1.475-.931-2.405-.931-.492 0-.896.437-.896.969v5.472c0 .532.404.969.896.969.983 0 2.001-.399 2.651-1.197.702-.798 1.019-1.672 1.3-2.736.28-1.064.456-2.204.456-3.401C22.965 8.206 18.522 3 13.009 3z" />
  </svg>
);
